import * as types from './types';
export function addProgressBar(progressBar) {
    return function (dispatch) {
        dispatch({ type: types.ADD_PROGRESS_BAR, payload: progressBar });
    };
}
export function removeProgressBar(id) {
    return function (dispatch) {
        dispatch({ type: types.REMOVE_PROGRESS_BAR, payload: id });
    };
}
export function setProgressBarValues(id, percent) {
    return function (dispatch) {
        dispatch({ type: types.SET_PROGRESS_VALUE, payload: { id: id, percent: percent } });
        if (percent === 100) {
            window.setTimeout(function () { return dispatch(removeProgressBar(id)); }, 2000);
        }
    };
}
